<template>
  <div class="wrapper">
    <!-- 头部 -->
    <div class="header-wrapper">
      <div class="header">
        <div class="tab box">
          <div class="tab1 tab-item select">列表</div>
          <div class="tab2 tab-item" @click="toStatics">统计</div>
        </div>
        <div class="header-text">居民</div>
        <div class="btn-wrapper">
          <Button class="bkcc-btn" @click="importCitizen">导入居民</Button>
          <Button class="bkcc-btn" @click="donwLoadList">导出居民</Button>
          <Button class="bkcc-btn" @click="showAddCitizen">新增居民</Button>
        </div>
      </div>
    </div>
    <!-- modal  -->
    <Modal
      v-model="isShowDelete"
      title="删除"
      width="660px"
      @on-ok="onDelete"
      @on-cancel="onCancel"
    >
      <div>确定删除该居民吗？</div>
    </Modal>
    <Modal
      v-model="isDelAll"
      title="删除"
      width="660px"
      @on-ok="delAll"
      @on-cancel="cancelDel"
    >
      <div>确定删除这些居民吗？</div>
    </Modal>
    <Modal v-model="isShowMove" title="移动至" width="580">
      <div class="add-wrapper">
        <div class="add-item">
          <label class="add-label">移动至</label>
          <RadioGroup v-model="addTo" size="large" @on-change="radioChange">
            <Radio label="微支部"></Radio>
            <Radio label="微社区"></Radio>
          </RadioGroup>
        </div>
        <div class="add-item">
          <label class="add-label">请选择</label>
          <Select v-model="selName" style="width:500px" @on-change="selChange">
            <Option v-for="item in selList" :value="item.id" :key="item.id">{{
              item.label
              }}
            </Option>
          </Select>
        </div>
      </div>
      <div slot="footer">
        <Button class="add-confirm" @click="clearModel">取消</Button>
        <Button class="add-confirm" type="warning" @click="sendEditScore"
        >确认
        </Button
        >
      </div>
    </Modal>
    <!-- 居民列表 -->
    <people-list
      :userList="userList"
      @cardClick="toDetail"
      @delPeople="delPeople"
      v-on:checkList="getCheckList"
      :checkList="checkList"
    ></people-list>
    <div class="fenye box">
      <div class="clickAll box">
        <i
          class="iconfont icon-clickall"
          :class="[clickAll ? 'icon-duoxuan1' : 'icon-duoxuankuang1']"
          @click="checkAll"
        ></i>
        全选(当前页)
      </div>
      <!-- <Page
        :total="total"
        class="page box_f1"
        :current="pageNum"
        :page-size="pageSize"
        @on-change="handleChangePage"
        show-total
      /> -->
      <scroll-page class="page box_f1" :total="total" :current="pageNum" :pagesize="pageSize" @on-change="handleChangeScrollPage"></scroll-page>
      <div class="clickTotal box">
        已选
        <span style="font-size:18px;color: #fe7d43">{{
          checkList.length
        }}</span>
      </div>
      <div class="clickBtn box">
        <Button type="success" @click="shAll" :disabled="btnDisabled"
        >审核通过
        </Button
        >
        <Button
          type="warning"
          @click="showMove"
          :disabled="btnDisabled"
          v-if="isShowBtn"
        >移动至
        </Button
        >
        <Button type="error" @click="showDelAll" :disabled="btnDisabled"
        >删除
        </Button
        >
      </div>
    </div>
    <!-- 新增居民 modal -->
    <Modal
      v-model="addCitizen"
      title="新增居民"
      width="580"
      @on-visible-change="onVisibleChange"
      class-name="vertical-center-modal"
    >
      <!-- 内容区域 -->
      <div class="add-wrapper">
        <div class="add-item" v-for="item in addCitizenList" :key="item.text">
          <label class="add-label">{{ item.text }}</label>
          <Input
            class="add-input"
            v-model="item.value"
            :placeholder="item.placeHolder"
            clearable
          />
        </div>
        <div class="add-item">
          <label class="add-label">微支部</label>
          <Select
            v-model="selName1"
            style="width:500px"
            @on-change="selChange1"
          >
            <Option
              v-for="item in partyList"
              :value="item.zoneId"
              :key="item.id"
            >{{ item.zoneName }}
            </Option
            >
          </Select>
        </div>
        <div class="add-item">
          <label class="add-label">微社区</label>
          <Select
            v-model="selName2"
            style="width:500px"
            @on-change="selChange2"
          >
            <Option
              v-for="item in zoneList"
              :value="item.zoneId"
              :key="item.id"
            >{{ item.zoneName }}
            </Option
            >
          </Select>
        </div>
      </div>
      <!-- 重写 底部 -->
      <div slot="footer">
        <span class="add-clear" @click="addClear">清空</span>
        <Button
          class="add-confirm"
          type="warning"
          :loading="addLoading"
          @click="addConfirm"
        >确认
        </Button
        >
      </div>
    </Modal>
    <!--导入居民-->
    <Modal
      v-model="importModal"
      title="导入居民"
      width="660px"
      height="400px"
      :footer-hide="true"
    >
      <!--/assets/企业导入模板.xlsx-->
      <div class="note box">
        请上传符合模板要求的居民文件,支持.xlsx格式
        <div class="download" @click="downModel">下载模板</div>
      </div>
      <Upload
        ref="upload"
        :show-upload-list="false"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :headers="header"
        :action="actionuri"
        :on-success="handleSuccess"
        :on-progress="handleProgress"
        :on-error="handleError"
      >
        <Button :loading="uploadLoading" type="primary">导入居民</Button>
      </Upload>
    </Modal>
  </div>
</template>
<script>
  import peopleList from "./components/peopleList";
  import scrollPage from "./components/scrollPage";
  var that;
  export default {
    data() {
      return {
        deleteUnionid: "",
        deleteCommunityid: "",
        deleteApptype:'',
        isShowDelete: false,
        pageNum: 1, // 分页1
        pageSize: 12, //  分页尺寸
        userList: [], // 用户列表
        addCitizen: false, // 是否显示新增居民
        addLoading: false, // 新增居民的loading btn
        added: false, // 判断是否进行了新增操作 并成功
        rule: {
          realNameStatus: "",
          labelParam: {},
          residentName: "",
          communityIdList: [this.$store.state.streetorcommunityid],
          fieldParam: {
            rnf_religion: [],
            rnf_national: []
          }
        }, // 过滤器筛选类型
        filterList: [],
        checkList: [],
        addCitizenList: [
          {
            text: "姓名",
            placeHolder: "请输入姓名",
            value: ""
          },
          {
            text: "电话",
            placeHolder: "请输入电话",
            value: ""
          },
          {
            text: "身份证",
            placeHolder: "请输入身份证号",
            value: ""
          }
        ],
        total: 2,
        clickAll: false,
        isDelAll: false,
        isShowMove: false,
        addTo: "微支部",
        btnDisabled: true,
        partyList: [],
        zoneList: [],
        selList: [],
        selVal: "",
        unionId: "",
        isShowBtn: true,
        selName: "",
        selName1: "",
        selName2: "",
        selVal1: null,
        selVal2: null,
        zoneIdList: [],
        header: {
          //令牌，为上传图片使用
          token: window.sessionStorage.getItem("token")
        },
        actionuri: "",
        importModal: false,
        uploadLoading: false,
        select: {}
      };
    },
    created() {
      that = this;
      this.reset = this._.debounce(this._reset, 500); // filter 重置后会触发
      this.actionuri = this.urlobj.importCitizen;
    },
    mounted() {
      this.getResdient()
      this.getfilter();
      // 街道的 改由getfilter全选触发
      //if(this.$store.state.isJiedao != 1) {
        //alert('isJIedao')
      //}
    },
    destroyed() {
      this.$store.commit("updateFilterList", []);
      this.$store.commit("updateLabelList", []);
    },
    watch: {
      /* 当前total发生变化时 右侧label显示跟着变化 */
      total(newVal) {
        this.$store.commit("updateLabelList", [
          {
            name: "filter_label",
            data: {
              label: "当前总人数",
              value: newVal
            }
          }
        ]);
      }
    },
    methods: {
      getfilter() {
        var getReligion = this.getReligionList();
        var getNational = this.getNationalList();
        var getCommunity = this.getCommunity();
        Promise.all([getReligion, getNational, getCommunity]).then(res => {
          this.$store.commit("updateSpinShow", false);
          let select = {
            name: "selecter",
            data: {
              title: "筛选",
              selectList: [
                {
                  title: "宗教信仰",
                  list: res[0].rows.map(item => {
                    return {
                      label: item.dicName,
                      value: item.id
                    };
                  }),
                  model: "",
                  value: "rnf_religion"
                },
                {
                  title: "民族分类",
                  list: res[1].rows.map(item => {
                    return {
                      label: item.dicName,
                      value: item.id
                    };
                  }),
                  model: "",
                  value: "rnf_national"
                }
              ]
            },
            event: function (e) {
              that[e.fn](e);
            }
          };
          let filterData = res[2].rows;
          this.filterList = []; // 置空
          // category
          filterData = filterData.filter(item => {
            return item.type != "category";
          });
          if (this.$store.state.isJiedao == 1) {
            this.isShowBtn = false;
            filterData = filterData.filter(item => {
              return item.type != "party" && item.type != "zone";
            });
            var _url = this.urlobj.getDivision("resident");
            this.$get(_url).then(res => {
              var list = res.rows.map(item => {
                return {
                  name: item.communityName,
                  id: item.communityId,
                  userCount: item.count
                };
              });
              filterData.unshift({
                type: "community",
                name: "行政区域",
                children: list,
                extraData: {
                  showSelectAll: true,
                  checkAll:true, // 默认全部选中
                }
              });
              for (const obj in filterData) {
                this.filterList.push(new FilterItem(filterData[obj]));
              }
              this.filterList.unshift(select);
              this.initFilterList(this.filterList);
            });
          } else {
            /* 初始化分类对象 */
            for (const obj in filterData) {
              this.filterList.push(new FilterItem(filterData[obj]));
            }
            this.filterList.unshift(select);
            this.initFilterList(this.filterList);
          }
        });
      },
      /* 获取宗教信仰字典 */
      getReligionList() {
        let url = this.urlobj.dictionaryList("religion");
        return new Promise((resolve, reject) => {
          this.$get(url)
            .then(res => {
              resolve(res);
            })
            .catch(e => console.log(e));
        });
      },
      /* 获取民族分类字典 */
      getNationalList() {
        let url = this.urlobj.dictionaryList("national");
        return new Promise((resolve, reject) => {
          this.$get(url)
            .then(res => {
              resolve(res);
            })
            .catch(e => console.log(e));
        });
      },
      toStatics() {
        this.$router.replace({name: "userStatics"});
      },
      getCheckList(checkList) {
        this.checkList = checkList;
        let len1 = this.checkList.length;
        let len2 = this.userList.length;
        this.btnDisabled = len1 == 0;
        if (len1 == len2) {
          this.clickAll = true;
        } else {
          this.clickAll = false;
        }
      },
      checkAll() {
        this.clickAll = !this.clickAll;
        if (this.clickAll == true) {
          this.checkList = [];
          this.userList.forEach(item => {
            item.clickCheck = true;
            this.checkList.push(item);
          });
          this.btnDisabled = false;
        } else {
          this.userList.forEach(item => {
            item.clickCheck = false;
          });
          this.btnDisabled = true;
          this.checkList = [];
        }
      },
      /**批量审核 */
      shAll() {
        var idlist = this.rule.communityIdList;
        if (this.$store.state.isJiedao == 1) {
          if (!idlist.length || idlist.length > 1) {
            this.$Message.warning("请选择一个行政区域");
            return;
          }
        }
        let unionId = this.checkList.map(item => {
          return item.unionId;
        });
        let url = this.urlobj.shenheAll("resident");
        let communityId = "";
        if (this.$store.state.isJiedao == 1) {
          communityId =
            this.rule.communityIdList == []
              ? this.$store.state.streetorcommunityid
              : this.rule.communityIdList.join(",");
        } else {
          communityId = this.$store.state.streetorcommunityid;
        }
        this.$post(url, {
          unionIds: unionId.join(","),
          status: 1,
          communityId
        }).then(res => {
          this.$Message.success(res.message);

          this.userList.forEach(item => {
            item.clickCheck = false;
          });
          this.checkList = [];
          this.clickAll = false;
          this.btnDisabled = true;
          this._reset();
        });
      },
      /**批量删除 */
      showDelAll() {
        console.log(this.checkList)
        var idlist = this.rule.communityIdList;
        if (this.$store.state.isJiedao == 1) {
          if (!idlist.length || idlist.length > 1) {
            this.$Message.warning("请选择一个行政区域");
            return;
          }
        }
        this.isDelAll = true;
      },
      delAll() {
        let unionId = this.checkList.map(item => {
          return item.unionId;
        });
        let url = this.urlobj.delAll;
        let communityId = "";
        if (this.$store.state.isJiedao == 1) {
          communityId =
            this.rule.communityIdList == []
              ? this.$store.state.streetorcommunityid
              : this.rule.communityIdList.join(",");
        } else {
          communityId = this.$store.state.streetorcommunityid;
        }
        this.$delete(url, {
          unionId: unionId.join(","),
          userType: "resident",
          communityId
        }).then(res => {
          this.isDelAll = false;
          this.$Message.success(res.message);
          this.checkList = [];
          this.clickAll = false;
          this.btnDisabled = true;
          this._reset();
        });
      },
      cancelDel() {
        this.isDelAll = false;
      },
      /**批量移动 */
      showMove() {
        var idlist = this.rule.communityIdList;
        if (this.$store.state.isJiedao == 1) {
          if (!idlist.length || idlist.length > 1) {
            this.$Message.warning("请选择一个行政区域");
            return;
          }
        }
        let in1 = "";
        let in2 = "";
        this.filterList.forEach((item, index) => {
          if (item.type == "party") {
            return (in1 = index);
          } else if (item.type == "zone") {
            return (in2 = index);
          }
        });
        this.partyList = this.filterList[in1].data.dataList;
        this.zoneList = this.filterList[in2].data.dataList;
        this.selList = this.partyList;
        let unionId = this.checkList.map(item => {
          return item.unionId;
        });
        this.unionId = unionId.join(",");
        this.isShowMove = true;
      },
      radioChange() {
        switch (this.addTo) {
          case "微支部":
            this.selList = this.partyList;
            break;
          case "微社区":
            this.selList = this.zoneList;
        }
      },
      selChange(value) {
        this.selVal = value;
      },
      clearModel() {
        this.isShowMove = false;
        this.selVal = "";
      },
      sendEditScore() {
        let data = {};
        switch (this.addTo) {
          case "微支部":
            data = {
              labelParam: {party: this.selVal}
            };
            break;
          case "微社区":
            data = {
              labelParam: {zone: this.selVal}
            };
        }
        data.unionId = this.unionId;
        let url = this.urlobj.sortToLabel();
        this.$post(url, data).then(res => {
          this.selVal = "";
          this.$Message.success(res.message);
          console.log(this.checkList);
          // console.log(123)
          // this.checkList.forEach(item => {
          //   item.clickCheck = false
          // })
          // this.filterList[e.filterListIndex].data.dataList[e.elIndex]
          //       .number = this.filterList[e.filterListIndex].data.dataList[e.elIndex]
          //       .number + this.checkList.length
          this.checkList = [];
          this.clickAll = false;
          this.btnDisabled = true;
          this._reset();
          this.isShowMove = false;
        });
      },
      selChange1(value) {
        this.selVal1 = value;
      },
      selChange2(value) {
        this.selVal2 = value;
      },
      showAddCitizen() {
        var idlist = this.rule.communityIdList;
        if (this.$store.state.isJiedao == 1) {
          if (!idlist.length || idlist.length > 1) {
            this.$Message.warning("请选择一个行政区域");
            return;
          }
        }
        this.addCitizen = true;
        let url = this.urlobj.getOrg();
        let communityId = "";
        if (this.$store.state.isJiedao == 1) {
          communityId =
            this.rule.communityIdList == []
              ? this.$store.state.streetorcommunityid
              : this.rule.communityIdList.join(",");
        } else {
          communityId = this.$store.state.streetorcommunityid;
        }
        let data1 = {
          communityId,
          zoneType: 1
        };
        let data2 = {
          communityId,
          zoneType: 2
        };
        //获取微社区
        this.$get(url, data1).then(res => {
          console.log(res);
          this.zoneList = res.rows;
        });
        //获取微支部
        this.$get(url, data2).then(res => {
          console.log(res);
          this.partyList = res.rows;
        });
      },
      clearSel() {
      },
      /* 确认添加新用户 */
      addConfirm() {
        this.zoneIdList = [];
        var partyId = [];
        var zoneId = [];
        if (this.selVal1) {
          this.zoneIdList.push(this.selVal1);
          partyId.push(this.selVal1);
        }
        if (this.selVal2) {
          this.zoneIdList.push(this.selVal2);
          zoneId.push(this.selVal2);
        }
        // return
        if (this.partyList.length == 0 && this.zoneList.length == 0) {
          this.$Message.warning("请创建微社区或微支部");
          return;
        }
        if (this.zoneIdList.length == 0) {
          this.$Message.warning("请选择微社区或微支部");
          return;
        }
        // 获取输入值 解构与数组的顺序有关
        let [realName, phoneNO, idCardNO] = this.addCitizenList.map(
          item => item.value
        );
        // 输入值校验
        if (!realName) {
          this.$Message.warning("姓名为必填项");
          return;
        }
        // 校验手机号
        if (!phoneNO) {
          this.$Message.warning("电话为必填项");
          return;
        }
        // let checkPhoneRes = this.$util.validatemobile(phoneNO);
        // if (!checkPhoneRes.result) {
        //   this.$Message.warning(checkPhoneRes.message);
        //   return;
        // }
        // 身份证号校验
        // let checkId = this.$util.IdentityCodeValid(idCardNO)
        // if (!checkId.result) {
        //   this.$Message.warning(checkId.message)
        //   return
        // }
        // 构建接口参数
        let communityId = "";
        if (this.$store.state.isJiedao == 1) {
          communityId =
            this.rule.communityIdList == []
              ? this.$store.state.streetorcommunityid
              : this.rule.communityIdList.join(",");
        } else {
          communityId = this.$store.state.streetorcommunityid;
        }
        let data = {
          realName: realName,
          phoneNO: phoneNO,
          idCardNO: idCardNO,
          zoneId: zoneId.join(""),
          partyId: partyId.join(""),
          communityId
        };
        this.addLoading = true; // 显示loading
        let url = this.urlobj.residentCheck();
        this.$post(url, data)
          .then(res => {
            this.addLoading = false; // 关闭loading
            if (res.isSucceed) {
              this.added = true; // 操作成功
              this.$Message.success("添加成功！");
            }
          })
          .catch(e => {
            this.addLoading = false;
          });
      },
      /* 清空输入 */
      addClear() {
        for (const item of this.addCitizenList) {
          item.value = "";
        }
        this.selName1 = "";
        this.selName2 = "";
        this.zoneIdList = [];
      },
      /* modal visible 发生变化 */
      onVisibleChange(e) {
        // 关闭弹窗时 刷新页面
        if (!e && this.added) {
          this._reset();
          this.added = false; // 重置操作flag
        }
      },
      /* 跳转居民详情 */
      toDetail(e) {
        this.$router.push({
          name: "citizenDetail",
          params: {
            unionId: e.unionId,
            communityId: e.communityId
          }
        });
      },
      /* 重置筛选列表 */
      _reset() {
        this.pageNum = 1; //  初始化分页
        this.userList = []; // 用户数据置空
        this.rule = {
          realNameStatus: "",
          labelParam: {},
          residentName: "",
          communityIdList: [this.$store.state.streetorcommunityid],
          fieldParam: {
            rnf_religion: [],
            rnf_national: []
          }
        };
        this.selName1 = "";
        this.selName2 = "";
        this.zoneIdList = [];
        this.getfilter();
        this.getResdient();
      },
      /* 返回新的时间戳 */
      _getTime() {
        return new Date().getTime();
      },
      /* 获取右侧筛选分类 */
      getCommunity() {
        let url = this.urlobj.resident();
        return new Promise((resolve, reject) => {
          this.$get(url, {
            communityId: this.rule.communityIdList.join(",")
          })
            .then(res => {
              resolve(res);
            })
            .catch(e => console.log(e));
        });
      },
      // getfilter()
      /* 根据unionId 返回新增居民的用户名 */
      _getNewPersonName(unionId) {
        try {
          let reg = /^jczl_.*/g;
          if (reg.test(unionId)) {
            return "暂无绑定微信";
          } else return false;
        } catch (error) {
          console.log("存在异常数据");
        }
      },
      /* 获取居民列表 */
      getResdient() {
        let url = this.urlobj.residentList();
        this.$store.commit("updateSpinShow", true);
        this.$post(url, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.rule
        })
          .then(res => {
            this.$store.commit("updateSpinShow", false);
            this.total = res.total;
            /* zonetype 0--社区，1--小区，2--微支部 */
            /* realNameStatus 0--待审核，1--未实名，2--已实名 */
            if (res.isSucceed) {
              /* 如果有数据 */
              if (res.rows.length) {
                /* 初始化数据 */
                this.userList = res.rows.map((item, index) => {
                  let orglist = item.zoneList;
                  if (orglist && orglist.length == 3) {
                    orglist.splice(0, 1);
                  }

                  return {
                    communityId: item.communityId,
                    showCha: false,
                    headPicUrl: item.headPicUrl, // 头像
                    name:
                      item.residentName ||
                      this._getNewPersonName(item.unionId) ||
                      "未知用户", // 昵称
                    unionId: item.unionId, // unionid
                    realName: item.realName, // 真实姓名
                    authState: item.realNameStatus, // 实名认证状态
                    orglist: orglist,
                    isParty: item.roleIdList.indexOf(2) > -1 ? 1 : 0,
                    isVol: item.roleIdList.indexOf(17) > -1 ? 1 : 0,
                    clickCheck: false,
                    appType:item.appType
                  };
                });
                ///zoneType:0 社区 1 微社区 2 微支部
                ///realNameStatus：1 已实名 0 未认证  -1 待审核
              } else {
                this.userList = [];
                /* 如果没有数据 完成加载 */
                // loadingContext.complete();
              }
            }
          })
          .catch(e => {
            console.log(e);
          });
        // this.pageNum += 1; // 分页加1
      },
      delPeople(query) {
        let appType = query.appType
        let source = this.rule.labelParam.source
        if(source){
          let appTypeArr = appType.split(',')
          appType = source.filter(item=>appType.includes(item)).join(',')
        }
        this.isShowDelete = true;
        this.deleteUnionid = query.unionId;
        this.deleteCommunityid = query.communityId;
        this.deleteApptype = appType
      },
      onDelete() {
        var url = this.urlobj.deletePeople(this.deleteUnionid);
        url += "?userType=resident&communityId=" + this.deleteCommunityid + '&appType='+this.deleteApptype;
        this.isShowDelete = false;
        this.$delete(url)
          .then(res => {
            if (res.isSucceed) {
              this.$Message.success("删除成功");
              //删除用户
              this.pageNum = 1; //  初始化分页
              this.userList = []; // 用户数据置空
              this.checkList = [];
              this.clickAll = false;
              this.btnDisabled = true;
              this.rule.communityIdList = []
              this.getResdient();
              // this.getfilter();
            } else {
              this.$Message.error(res.message);
            }
          })
          .catch(e => {
            this.$Message.error("删除失败");
          });
      },
      onCancel() {
        this.isShowDelete = false;
      },
      handleChangePage(val) {
        this.pageNum = val;
        this.checkList = [];
        this.clickAll = false;
        this.btnDisabled = true;
        this.getResdient();
      },
      handleChangeScrollPage(val){
        if(parseInt(val) == 1){
          this.pageNum++
        }else{
          this.pageNum--
        }
        this.checkList = [];
        this.clickAll = false;
        this.btnDisabled = true;
        this.getResdient();
      },
      /* 初始化筛选列表 */
      initFilterList(list) {
        /* search 数据 */
        let search = {
          name: "search",
          data: {},
          event: function (e) {
            that[e.fn](e);
          }
        };
        /* 认证状态对象 */
        let authState = {
          name: "authstate",
          data: {
            title: "实名状态",
            stateList: [
              {
                value: "已实名",
                stateCode: 1,
                stateColor: "#47ba54",
                active: false
              },
              {
                value: "待审核",
                stateCode: -1,
                stateColor: "#ff7744",
                active: false
              },
              {
                value: "未认证",
                stateCode: 0,
                stateColor: "#a1afb3",
                active: false
              }
            ]
          },
          event: function (e) {
            that[e.fn](e);
          }
        };
        list.unshift(search, authState);
        this.$store.commit("updateFilterList", list);
      },
      /* ---------------------所有 筛选 业务处理 代码 如下--------------------*/

      /* ==================== 搜索  BEGIN==================== */
      search({params}) {
        this.pageNum = 1; //  初始化分页
        this.userList = []; // 用户数据置空
        this.rule.residentName = params.searchValue;
        // this.pageNum = val;
        this.checkList = [];
        this.clickAll = false;
        this.btnDisabled = true;
        this.getResdient();
      },
      /* ==================== 搜索  END==================== */
      /* ==================== 认证状态  BEGIN==================== */
      authchange({params}) {
        this.pageNum = 1; //  初始化分页
        this.userList = []; // 用户数据置空
        this.rule.realNameStatus = params.stateCode; // 筛选条件更新
        // this.pageNum = val;
        this.checkList = [];
        this.clickAll = false;
        this.btnDisabled = true;
        this.getResdient();
      },
      /* ==================== 认证状态  END==================== */
      /* ==================== 分类  BEGIN==================== */
      /* 分类模块添加分类 */
      addSort({params}) {
        let url = this.urlobj.addLabel();
        let data = {
          labelType: 1, // 居民列表页 是1
          name: params.addValue
        };
        this.$store.commit("updateSpinShow", true);
        this.$post(url, data)
          .then(res => {
            if (res.isSucceed) {
              this.$Message.success("添加成功");
              this.getfilter();
            }
          })
          .catch(e => console.log(e));
      },
      /* 删除模块删除分类 */
      delSort({params}) {
        let target = this.filterList[params.filterListIndex];
        let delId = target.data.dataList[params.delIndex].id;
        let url = this.urlobj.delLabel(delId);
        this.$store.commit("updateSpinShow", true);
        this.$delete(url)
          .then(res => {
            this.$store.commit("updateSpinShow", false);
            if (res.isSucceed) {
              this.$Message.success("删除成功");
              target.data.dataList.splice(params.delIndex, 1);
            }
          })
          .catch(e => console.log(e));
      },
      /* 拖曳到分类 */
      sortDrop({params}) {
        this._drop(params);
      },
      /* 勾选筛选选项 */
      sortChange({params}) {
        this._groupChange(params);
      },
      /* ==================== 分类  END==================== */
      /* ==================== 行政区域  BEGIN==================== */
      areaChange({params}) {
        this._groupChange(params);
      },
      /* ==================== 分类  END==================== */
      /* ==================== 微支部  BEGIN==================== */
      orgChange({params}) {
        this._groupChange(params);
      },
      orgDrop({params}) {
        this._drop(params);
      },
      /* ==================== 微支部  END==================== */
      /* ==================== 小区  BEGIN==================== */
      comDrop({params}) {
        this._drop(params);
      },
      comChange({params}) {
        this._groupChange(params);
      },
      /* ==================== 小区  END==================== */
      /* ==================== 来源  BEGIN==================== */
      oriChange({params}) {
        this._groupChange(params);
      },
      oriDrop({params}) {
        // this._drop(params);
      },
      /* ==================== 来源  END==================== */
      /* ==================== 排序  BEGIN==================== */
      sort({params}) {
        this.rule.fieldParam[params.key][0] = params.val;
        this.getResdient();
        this.checkList = [];
        this.btnDisabled = true;
        this.clickAll = false;
      },
      /* ==================== 排序  END==================== */
      /******************* 公用方法 ************************/
      /* 勾选筛选 初始化不同的属性*/
      _groupChange(e) {
        let target = this.filterList[e.filterListIndex];
        this.pageNum = 1; //  初始化分页
        this.userList = []; // 用户数据置空

        /* 修改筛选条件 source 传type 其他的传id*/
        if (target.type == "source") {
          this.rule.labelParam[target.type] = e.selectedIndex.map(item => {
            return target.data.dataList[item].type;
          });
        } else if (target.type == "community") {
          this.rule.communityIdList = e.selectedIndex.map(
            item => target.data.dataList[item].id
          );
        } else {
          this.rule.labelParam[target.type] = e.selectedIndex.map(item => {
            return target.data.dataList[item].id;
          });
        }
        // this.pageNum = 1
        this.getResdient();
        this.checkList = [];
        this.btnDisabled = true;
        this.clickAll = false;
      },
      /* 拖曳放开
      2018年12月20日 暂时关闭
      */
      _drop(e) {
        let target = this.filterList[e.filterListIndex];
        let url = this.urlobj.sortToLabel();
        if (
          target.type == "community" &&
          typeof target.data.dataList[e.elIndex].id != "number"
        ) {
          this.$Message.warning("请选择正确的行政区域");
          return;
        }
        let data = {
          labelParam: {
            [target.type]: target.data.dataList[e.elIndex].id
          },
          unionId: e.dropValue
        };
        this.$store.commit("updateSpinShow", true);
        this.$post(url, data)
          .then(res => {
            this.$store.commit("updateSpinShow", false);
            if (res.isSucceed) {
              this.$Message.success("添加成功");
              this.filterList[e.filterListIndex].data.dataList[e.elIndex]
                .number++;
              this.getResdient();
              this.getfilter();
            }
          })
          .catch(e => {
            this.$store.commit("updateSpinShow", false);
            console.log(e);
          });
      },
      // 下载模板
      downModel() {
        var communityIds = "";
        if (this.$store.state.isJiedao == 1) {
          communityIds =
            this.rule.communityIdList == []
              ? this.$store.state.streetorcommunityid
              : this.rule.communityIdList.join(",");
        } else {
          communityIds = this.$store.state.streetorcommunityid;
        }
        let url = this.urlobj.downCitizenModel + "?communityId=" + communityIds
        window.open(url);
      },
      importCitizen() {
        var idlist = this.rule.communityIdList;
        if (this.$store.state.isJiedao == 1) {
          if (!idlist.length || idlist.length > 1) {
            this.$Message.warning("请选择一个行政区域");
            return;
          }
        }
        //重置上传接口，避免接口参数重复
        this.actionuri = this.urlobj.importCitizen;
        let communityId = "";
        if (this.$store.state.isJiedao == 1) {
          communityId =
            this.rule.communityIdList == []
              ? this.$store.state.streetorcommunityid
              : this.rule.communityIdList.join(",");
        } else {
          communityId = this.$store.state.streetorcommunityid;
        }
        this.actionuri += `?communityId=${communityId}`;
        this.importModal = true;
      },
      handleProgress() {
        this.uploadLoading = true;
      },
      handleSuccess(response) {
        this.uploadLoading = false;
        this.importModal = false;
        if (response.isSucceed) {
          this.$Message.success("导入成功");
          this.pageNum = 1; //  初始化分页
          this.userList = []; // 用户数据置空
          this.checkList = [];
          this.clickAll = false;
          this.btnDisabled = true;
          this.getResdient();
          this.getfilter();
        } else {
          this.$Message.error(response.message);
        }
      },
      handleError() {
        this.uploadLoading = false;
        this.importModal = false;
        this.$Message.error("导入失败");
      },
      donwLoadList() {
        var idlist = this.rule.communityIdList;
        if (this.$store.state.isJiedao == 1) {
          if (!idlist.length || idlist.length > 1) {
            this.$Message.warning("请选择一个行政区域");
            return;
          }
        }
        let url = this.urlobj.downCitizen;
        var communityIds = "";
        if (this.$store.state.isJiedao == 1) {
          communityIds =
            this.rule.communityIdList == []
              ? this.$store.state.streetorcommunityid
              : this.rule.communityIdList.join(",");
        } else {
          communityIds = this.$store.state.streetorcommunityid;
        }
        var realNameStatus = this.rule.realNameStatus;
        var residentName = this.rule.residentName;
        var source = this.rule.labelParam.source
          ? this.rule.labelParam.source.join(",")
          : "";

        // "&labelParam=" +
        // labelParam +
        url =
          url +
          "?communityId=" +
          communityIds +
          "&realNameStatus=" +
          realNameStatus +
          "&source=" +
          source +
          "&residentName=" +
          residentName;
        console.log(url);
        window.open(url);
      }
    },
    components: {
      peopleList,
      scrollPage
    }
  };

  /* ---------------------------筛选组件构造对象 --------------------------*/
  /*
    type : 用来确定 使用哪个组件
    name ：组件显示的头部文字
    children: 子列表数据
    extraData: 组件的特殊配置对象，通过data传输
  */
  function FilterItem({type, name, children, selectedIndex, extraData = {}}) {
    /* 如果是来源 获取图片路径 */

    this._getIconPath = function (type, obj) {
      
      if (type == "source") {
        switch (obj.type) {
          case "gzh":
            return require("../../assets/images/filter/gzh.png");
          case "xfej":
            return require("../../assets/images/filter/xfej.png");
          case "mst":
            return require("../../assets/images/filter/mst.png");
          case "jczl_mst":
          case "jczl_ctt": 
          case "jczl_ipy": 
            return require("../../assets/images/filter/jm.png");
          case "jczl_xfej":
          case "jczl_ctxf":
            return require("../../assets/images/filter/dy.png");
          case "ipy":
            return require("../../assets/images/filter/ipuyang.png")
          case "ctt":
            return require("../../assets/images/filter/ctt.png")
          case "ctxf":
            return require("../../assets/images/filter/ctxf.png")
          case "dxbst":
            return require("../../assets/images/filter/dxbst.png")
          case "dxxf":
            return require("../../assets/images/filter/dxxf.png")
          default:
            return require("../../assets/images/filter/jm.png");
        }
      } else {
        return "";
      }
    };
    /* 是否可编辑 以后扩展*/
    this.editMode = function (type) {
      switch (type) {
        case "category":
          return true;
        default:
          return false;
      }
    };
    /* 初始化 组件类型 this.name 确定组件类型*/
    switch (type) {
      case "category":
        this.name = "sort";
        break;
      case "party":
        this.name = "microorg";
        break;
      case "source":
        this.name = "origin";
        break;
      case "zone":
        this.name = "community";
        break;
      case "community":
        this.name = "community";
        break;
    }
    /* 对象类型 */
    this.type = type;
    /* 初始化对象 数据 */
    this.data = {
      title: name, // 解构过来的name
      edit: this.editMode(type),
      dataList: children.map((item, index) => {
        return {
          id: item.id,
          label: item.name,
          number: item.userCount,
          iconPath: this._getIconPath(type, item),
          type: item.type || ""
        };
      }),
      ...extraData
    };
    if (selectedIndex > -1) {
      this.data.selectedIndex = selectedIndex;
    }
    /* 初始化对象事件 写死的 由当前组件对象去处理业务逻辑，没有相关函数会报错*/
    this.event = function (e) {
      that[e.fn](e);
    };
  }
</script>

<style lang="less" scoped>
  /* 头部信息 开始 */
  .wrapper {
    color: #666666;
    min-height: 100.1%; // 强制滚动
    // margin-right: -17px;
  }

  .header-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .header {
    width: 98%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 100px auto 100px;
    justify-items: center;
    align-items: center;
    font-size: 25px;
    position: relative;
    .header-text {
      grid-column: 2;
    }

  }

  /* 头部信息 结束 */
  /* 新增居民 modal 开始 */
  .add-wrapper {
    min-height: 360px;
  }

  .add-item {
    display: flex;
    align-items: center;
  }

  .add-label {
    min-width: 4em;
    white-space: nowrap;
    text-align: right;
    font-size: 18px;
    color: #666;
    margin: 15px 10px 15px 0;
  }

  .add-input {
    flex: 1;
  }

  // 清空按钮
  .add-clear {
    color: #999;
    margin-right: 30px;
    cursor: pointer;
    &:hover {
      color: #ff9568;
    }
  }

  // 确认按钮
  .add-confirm {
    background-color: #ff5a32;
    line-height: 1;
  }

  /* 新增居民 modal 结束 */

  /*tab切换*/
  .tab {
    font-size: 12px;
    position: absolute;
    left: 20px;
    background: #fff;
    color: #a0a0a0;
    border-radius: 5px;
    font-size: 14px;
  }

  .tab1 {
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
  }

  .tab2 {
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
  }

  .tab-item {
    // width: 50px;
    text-align: center;
    height: 35px;
    line-height: 35px;
    cursor: default;
    padding: 0 15px;
  }

  .select {
    background: #ff7b44;
    color: #fff;
  }

  // 分页组件
  .fenye {
    // width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 150px;
    right: 255px;
    height: 40px;
    box-shadow: 0px -5px rgba(225, 225, 225, 0.5);
    // left: 40%
  }

  .page {
    // position: fixed;
    // left: 20%;
    // margin-bottom: 20px;
    margin-left: 50px;
    line-height: 40px
  }

  .clickAll {
    margin-left: 20px;
    line-height: 40px;
  }

  .clickTotal {
    // position: fixed;
    // left: 60%;
    line-height: 40px;
    // margin-left: 440px;
  }

  .clickBtn {
    // position: fixed;
    // left: 70%;
    margin-left: 80px;
    line-height: 40px;
    button {
      height: 30px;
      margin-right: 10px;
      line-height: 15px;
    }
  }

  /* 移动对话框 */
  .add-wrapper {
    min-height: 360px;
  }

  .add-item {
    display: flex;
    align-items: center;
  }

  .add-label {
    min-width: 4em;
    white-space: nowrap;
    text-align: right;
    font-size: 18px;
    color: #666;
    margin: 15px 10px 15px 0;
  }

  .add-input {
    flex: 1;
  }

  .icon-duoxuan1 {
    color: #d22c2b;
  }

  //导入导出
  .note {
    font-size: 16px !important;
    margin-bottom: 20px;
    .download {
      color: #ff7b44;
      text-decoration: underline;
      margin-left: 5px;
    }
  }

  /deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
      top: 0;
    }
  }
  .btn-wrapper{
    position: absolute;
    right: 0;
    display: flex;
  }
</style>
